//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { version } from '../../package.json';

export default {
  name: 'ViuSwitch',
  props: {
    /**
     * listado de opciones requerido
     * con dos opciones disponibles,
     * con value, text y disabled
     */
    options: {
      type: Array,
      required: true,
      validator(value) {
        const checkRequired = value.every(
          item => (item.value && item.text) || (item.value === 0 && item.text)
        );
        if (!checkRequired)
          throw new Error('Las opciones deben tener value y text obligatoriamente');

        const checkLength = value.length === 2;
        if (!checkLength) throw new Error('Un switch debe tener 2 opciones');

        return checkRequired && checkLength;
      }
    },
    /**
     * Determina si la botonora está habilitada
     */
    disabled: {
      type: Boolean,
      default: false
    },
    /**
     * determina si el componente es de lectura
     * cuando es true y modo default debe tener
     * elemento seleccionado
     */
    readOnly: {
      type: Boolean,
      default: false
    },
    /**
     * controla el valor seleccionado
     */
    value: [Number, String]
  },
  data() {
    return {
      selectedOption: '',
      version
    };
  },
  created() {
    if (!this.readOnly) {
      this.notReadOnly();
    } else {
      this.isReadOnly();
    }
  },
  methods: {
    notReadOnly() {
      /**
       * Esta es la funcionalidad cuando readOnly esta desactivado
       * Checkea si el value viene informado y si es correcto
       * si no viene informado asigna el primer valor por defecto,
       */
      if (!this.value && this.value !== 0 && !this.readOnly) {
        this.selectedOption = this.options[0].value;
        this.emitInput();
        return true;
      }
      const optionsSelected = this.options.some(option => option.value === this.value);
      if (!optionsSelected) {
        throw new Error('La opcion seleccionada no está entre las opciones disponibles');
      }
      this.selectedOption = this.value;
      return true;
    },
    checkInvalid() {
      return {
        status: false,
        reason: ''
      };
    },
    isReadOnly() {
      /**
       * Esta es la funcionalidad cuando readOnly esta activo
       * checkea que venga valor informado y se encuentre entre las opciones
       */
      if (this.value && this.options.some(option => option.value === this.value)) {
        this.selectedOption = this.value;
        return true;
      }
      throw new Error(
        'readOnly esta activo, el valor seleccionado no está entre las opciones o no viene informado'
      );
    },
    selectedItem(selected) {
      /**
       * realiza la llamada a callback
       * para realizar la emision del
       * valor al padre
       */
      if (this.readOnly || this.disabled) return false;
      this.selectedOption = selected;
      this.emitInput();
      return true;
    },
    emitInput() {
      /**
       * @event input
       * @property {string, number} selectedOption contiene el value de la opcion seleccionada
       */
      this.$emit('input', this.selectedOption);
    }
  }
};
